module.exports = __webpack_public_path__ + "assets/puntsDeVenda-min.9d7bd3d0409e9bd11a7960751be7ee85.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/CanGuidic/puntsDeVenda-min.jpg
 ** module id = 417
 ** module chunks = 0
 **/